import { EpimsBaseEntityDto } from './epim-base.dto';
export class LandTitleRegisterDto extends EpimsBaseEntityDto {
  LandTitleRegisterId: string;
  FileName: string;
  DocumentTitle: string;
  DocumentNo: string;
  LandTitleName: string;
  LandTitleCode: string;
  Url: string;
  Remarks: string;
  CreatePerson: string;
  CreateDate: Date;
  ApprovalStatus: string;
  FileLocationId: string;
  DocReturnStatus: string;
  ObligationDoc: string;
  AdrDocuments: string;
  DocumentTypeId: string;
  DocumentTypeCodeId: string;
  DocRefNo: string;
  DocumentId: string;
  SecurityId: string;
  SecurityClassificationName: string;
  DocMainRefNo: string;
  SubscriptionUserId: string;
  FilePath: string;
  FileType: string;
}
